import { usePostPortfolioCryptocurrenciesMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioCryptocurrenciesMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { CRYPTOCURRENCY_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/cryptocurrencyFormDefaults";
import { getCryptocurrencyFormSchema } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/cryptocurrencyFormSchema";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateCryptocurrencyForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioCryptocurrenciesMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getCryptocurrencyFormSchema(t),
		defaultValues: CRYPTOCURRENCY_FORM_DEFAULT_VALUES,
		mutate,
		successRoute: Routing.Portfolio.PortfolioAddCryptocurrencySuccess.path(),
	});

	return { form, onSubmit, isPending };
};
